import { Redirect } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import {IonLoading, IonText} from '@ionic/react';
import { useEffect, useState } from 'react';

const ProtectedRoute = ({ children, noMenu = false, requiredRules = [] }: any) => {
	const {token, claims, onSSO } = useAuth();
	const [ssoToken] = useState(new URLSearchParams(window.location.search).get("sso"));
	const [loading, setLoading] = useState(false);
	const [authorized, setAuthorized] = useState<boolean>(false);
	useEffect(() => {
		if (claims !== null) {
			validateClaims();
		}
	}, [claims]);

	useEffect(() => {
		const ssoSearchParams = new URLSearchParams(window.location.search).get("sso");
		if (ssoSearchParams) {
			setLoading(true);
			onSSO(ssoSearchParams).then(() => {
				validateClaims();
			}).catch((error: any) => {
				console.error(error);
				setAuthorized(false);
			}).finally(() => {
				setLoading(false);
			});
		}
	}, []);

	function validateClaims() {
		if (!claims?.userId && !claims?.amsId && !claims?.dashboardId) {
			return setAuthorized(false);
		}
		const rules = claims.rules ? claims.rules : [];
		for (const rule of requiredRules) {
			if (!rules.includes(rule)) {
				return setAuthorized(false);
			}
		}
		return setAuthorized(true);
	}
	return <>
		{!token && !ssoToken && <Redirect to="/"/>}
		<IonLoading
			isOpen={loading}
			message={'Loading...'}
		/>
		{!authorized && !loading && <IonText>Unauthorized</IonText>}
		{authorized && <>
			{!loading &&
				<>{children}</>
			}
		</>}
	</>
};

export default ProtectedRoute;